export default [
  { name: "United States Dollar (USD)", symbol: "$" },
  { name: "Euro (EUR)", symbol: "€" },
  { name: "British Pound Sterling (GBP)", symbol: "£" },
  { name: "Nigerian Naira (NGN)", symbol: "₦" },
  { name: "Japanese Yen (JPY)", symbol: "¥" },
  { name: "Chinese Yuan (CNY)", symbol: "¥" },
  { name: "Canadian Dollar (CAD)", symbol: "$" },
  { name: "Australian Dollar (AUD)", symbol: "$" },
  { name: "Swiss Franc (CHF)", symbol: "CHF" },
  { name: "Ghanaian Cedi (GHS)", symbol: "₵" },
  { name: "South African Rand (ZAR)", symbol: "R" },
  { name: "Kenyan Shilling (KES)", symbol: "KSh" },
  { name: "Ugandan Shilling (UGX)", symbol: "USh" },
  { name: "Tanzanian Shilling (TZS)", symbol: "TSh" },
  { name: "Indian Rupee (INR)", symbol: "₹" },
  { name: "Brazilian Real (BRL)", symbol: "R$" },
  { name: "Mexican Peso (MXN)", symbol: "$" },
  { name: "UAE Dirham (AED)", symbol: "د.إ" },
  { name: "Saudi Riyal (SAR)", symbol: "﷼" },
  { name: "Qatari Riyal (QAR)", symbol: "﷼" },
  { name: "Russian Ruble (RUB)", symbol: "₽" },
  { name: "Swedish Krona (SEK)", symbol: "kr" },
  { name: "Norwegian Krone (NOK)", symbol: "kr" },
  { name: "Danish Krone (DKK)", symbol: "kr" },
  { name: "Polish Zloty (PLN)", symbol: "zł" },
  { name: "Turkish Lira (TRY)", symbol: "₺" },
  { name: "Egyptian Pound (EGP)", symbol: "£" },
  { name: "Moroccan Dirham (MAD)", symbol: "د.م." },
  { name: "West African CFA Franc (XOF)", symbol: "CFA" },
  { name: "Central African CFA Franc (XAF)", symbol: "FCFA" },
  { name: "Botswana Pula (BWP)", symbol: "P" },
  { name: "Ethiopian Birr (ETB)", symbol: "Br" },
  { name: "Hong Kong Dollar (HKD)", symbol: "$" },
  { name: "Singapore Dollar (SGD)", symbol: "$" },
  { name: "New Zealand Dollar (NZD)", symbol: "$" },
  { name: "South Korean Won (KRW)", symbol: "₩" },
  { name: "Philippine Peso (PHP)", symbol: "₱" },
  { name: "Malaysian Ringgit (MYR)", symbol: "RM" },
  { name: "Indonesian Rupiah (IDR)", symbol: "Rp" },
  { name: "Pakistani Rupee (PKR)", symbol: "₨" },
  { name: "Sri Lankan Rupee (LKR)", symbol: "Rs" },
  { name: "Bangladeshi Taka (BDT)", symbol: "৳" },
  { name: "Thai Baht (THB)", symbol: "฿" },
  { name: "Vietnamese Dong (VND)", symbol: "₫" },
  { name: "Colombian Peso (COP)", symbol: "$" },
  { name: "Argentine Peso (ARS)", symbol: "$" },
  { name: "Chilean Peso (CLP)", symbol: "$" },
];